<template>
  <div class="bill-delivery-container">
    <checkout-payment-headline :title="$t('checkout.infoAndPayment.billDelivery')"/>
    <div class="delivery-options-container">
      <div v-for="(delivery, index) in deliveryOptions"
           :key="index"
           class="delivery-option">
        <div class="item">
          <BaseRadio v-model="setDeliveryType"
                     variant="red"
                     :name="delivery.type"
                     :value="delivery.type"
                     :label="delivery.title"
                     :checked="delivery.type === setDeliveryType || delivery.checked"/>
        </div>
        <div v-if="$props.deliveryType === 'bill-differentAddress' && delivery.type === 'bill-differentAddress'">
          <ShipmentForm v-model="$props.value" v-bind="$props"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BaseRadio from '../../base/base-radio'
import ShipmentForm from './shipment-form'
import CheckoutPaymentHeadline from './checkout-payment-headline'

export default {
  name: 'bill-delivery',
  components: { BaseRadio, ShipmentForm, CheckoutPaymentHeadline },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    deliveryType: String,
    cities: {
      type: Array,
      default: () => []
    },
    formSubmitted: Boolean
  },
  data () {
    return {
      deliveryOptions: [
        {
          title: this.$i18n.t('checkout.infoAndPayment.email'),
          type: 'bill-email',
          checked: true
        },
        {
          title: this.$i18n.t('checkout.infoAndPayment.sameAddress'),
          type: 'bill-sameAddress',
          checked: false
        },
        {
          title: this.$i18n.t('checkout.infoAndPayment.differentAddress'),
          type: 'bill-differentAddress',
          checked: false
        }
      ]
    }
  },
  computed: {
    setDeliveryType: {
      get () {
        return this.$props.deliveryType
      },
      set (val) {
        this.$emit('bill-delivery', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">

.bill-delivery-container {
  margin-bottom: 3rem;

  @media (map_get($breakpoints, sm)) {
    margin-bottom: 4rem;
  }

  .delivery-options-container {
    margin-bottom: 10px;
    background-color: $white;
    padding: 30px 15px 10px;
    @media (map_get($breakpoints, sm)) {
      padding-left: 40px;
    }
  }

  .delivery-option {
    display: flex;
    flex-direction: column;
    line-height: 1.71;
    margin-bottom: 25px;

    &:hover {
      cursor: pointer;
    }

    /deep/ .checkbox-label {
      color: $dark;
      font-size: 14px;
      font-weight: 600;
    }
  }

  .item {
    display: flex;
  }
}

</style>
